(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mh-reference-complement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-pillow-complement')) {
 customElements.define('mh-pillow-complement', class extends HTMLElement {
  connectedCallback() {
   this.select = this.querySelector('select');
   this.form = this.querySelector('form');
   this.button = this.form?.querySelector('button[type="submit"]');
   this.status = this.querySelector('[data-complement-status]');
   this.colors = JSON.parse(this.querySelector('[data-page-colors]').textContent);
   this.scope = this.closest('.shopify-section');
   this.normalize = value => {
    const color = String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    return ({minkbraun:'braun',mauve:'pflaumenrot',altrosa:'ziegelrot',grun:'salbeigrun',gruen:'salbeigrun'})[color] || color;
   };
   this.refresh = () => {
    const option = this.select.selectedOptions[0];
    if (!option) return;
    const image = this.querySelector('.mh-ref-complement-image');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    this.querySelectorAll('[data-complement-link]').forEach(link => { link.href = this.dataset.productUrl + '?variant=' + option.value; });
    const original = this.querySelector('[data-original-price]');
    const bundle = this.querySelector('.mh-ref-complement-price [data-bundle-price]');
    if (original) original.textContent = option.dataset.price;
    if (bundle) bundle.textContent = option.dataset.bundlePrice;
   };
   this.syncColor = event => {
    if (this.dataset.muslin !== 'true' || String(event.detail?.data?.productId) !== this.dataset.productId) return;
    const color = this.colors[event.detail?.resource?.id];
    if (!color) return;
    const match = [...this.select.options].find(option => !option.disabled && this.normalize(option.dataset.color) === this.normalize(color));
    if (match) { this.select.value = match.value; this.refresh(); }
   };
   this.handleSubmit = async event => {
    event.preventDefault();
    if (!this.form || !this.select || !this.button) return;
    const root = window.Shopify?.routes?.root || '/';
    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
     .map(component => component.dataset.sectionId)
     .filter(Boolean);
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    if (this.status) this.status.textContent = '';
    try {
     const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
       'Content-Type': 'application/json',
       Accept: 'application/json',
       'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
       items: [{ id: this.select.value, quantity: 1 }],
       sections: [...new Set(sectionIds)].join(','),
       sections_url: window.location.pathname
      })
     });
     const result = await response.json();
     if (!response.ok || result.status) {
      throw new Error(result.description || result.message || response.statusText);
     }
     let cart = {};
     try {
      const cartResponse = await fetch(`${root}cart.js`, {
       credentials: 'same-origin',
       headers: { Accept: 'application/json' }
      });
      if (cartResponse.ok) cart = await cartResponse.json();
     } catch (error) {
      cart = {};
     }
     this.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
       resource: cart,
       sourceId: this.form.id,
       data: {
        source: 'mh-pillow-complement',
        itemCount: 1,
        productId: this.dataset.productId,
        variantId: this.select.value,
        sections: result.sections || {}
       }
      }
     }));
     const drawer = document.querySelector('cart-drawer-component');
     if (drawer && !drawer.querySelector('dialog[open]') && typeof drawer.open === 'function') {
      drawer.open();
     }
    } catch (error) {
     if (this.status) this.status.textContent = error.message || '';
    } finally {
     this.button.disabled = false;
     this.button.removeAttribute('aria-busy');
    }
   };
   this.select.addEventListener('change', this.refresh);
   this.form?.addEventListener('submit', this.handleSubmit);
   this.scope?.addEventListener('variant:update', this.syncColor);
   this.refresh();
  }
  disconnectedCallback() {
   this.select?.removeEventListener('change', this.refresh);
   this.form?.removeEventListener('submit', this.handleSubmit);
   this.scope?.removeEventListener('variant:update', this.syncColor);
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mh-reference-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-reference-promo')) {
customElements.define('mh-reference-promo', class extends HTMLElement {
 connectedCallback() {
  this.values = JSON.parse(this.querySelector('script').textContent);
  this.update = (event) => {
   if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
   const value = this.values[event.detail?.resource?.id];
   if (!value) return;
   this.querySelector('[data-promo-container]').hidden = !value.sale;
   this.querySelector('[data-saving]').innerHTML = value.saving;
  };
  this.scope = this.closest('.shopify-section');
  this.scope?.addEventListener('variant:update', this.update);
 }
 disconnectedCallback() {this.scope?.removeEventListener('variant:update', this.update);}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mh-reference-variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-base-product-options')) {
  customElements.define('mh-base-product-options', class extends HTMLElement {
    connectedCallback() {
      this.normalize = () => {
        const inputs = [...this.querySelectorAll('.mh-ref-legacy-pillow-option input[type="radio"]')];
        const base = inputs.find(input => /ohne|without|sans|senza/i.test(input.value));
        if (base && !base.checked) base.click();
      };
      this.addEventListener('variant:update', this.normalize);
      requestAnimationFrame(this.normalize);
    }
    disconnectedCallback() { this.removeEventListener('variant:update', this.normalize); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
